import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "utils/api";
import toast from "react-hot-toast";
import {
  MdArrowBack,
} from "react-icons/md";

export default function NewBookingDetails() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    loadOrderDetails();
  }, [orderId]);

  const loadOrderDetails = async () => {
    try {

      const payload = { order_id: orderId };
      const res = await api.post("/transaction/", payload);

      if (res.data && res.data.length > 0) {
        setOrder(res.data[0]);
      } else {
        toast.error("No transaction details found.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load booking details.");
    }
  };

  if (!order) {
    return <div className="p-6 text-center text-gray-500">Loading...</div>;
  }

  return (
    <div className="p-6">
      <div className="rounded-xl bg-white p-6 shadow-lg border border-blue-100">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/admin/payment")}
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 shadow-sm transition hover:border-gray-300 hover:bg-gray-50"
            aria-label="Back to Runner Boys"
          >
            <MdArrowBack className="h-5 w-5" />
          </button>
          <div>
            <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">
              Order Details
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              Overview of order information
            </p>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full text-left">
            <tbody>
              <tr className="hover:bg-gray-50 transition-colors duration-200">
                <td className="px-6 py-4 font-medium text-gray-900 w-1/3">Order ID</td>
                <td className="px-6 py-4 text-gray-900">{order.order_id}</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors duration-200">
                <td className="px-6 py-4 font-medium text-gray-900">User</td>
                <td className="px-6 py-4 text-gray-900">{order.user_name}</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors duration-200">
                <td className="px-6 py-4 font-medium text-gray-900">Bill Amount</td>
                <td className="px-6 py-4 text-gray-900">Rs {order.bill_amount}</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors duration-200">
                <td className="px-6 py-4 font-medium text-gray-900">Payment Date</td>
                <td className="px-6 py-4 text-gray-900">{order.payment_date}</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors duration-200">
                <td className="px-6 py-4 font-medium text-gray-900">Payment Mode</td>
                <td className="px-6 py-4 text-gray-900">
                  {order.payment_mode === 1 ? "Credit Card" : "Other"}
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors duration-200">
                <td className="px-6 py-4 font-medium text-gray-900">Status</td>
                <td className="px-6 py-4">
                  <span
                    className={`px-3 py-1 rounded-full text-sm font-semibold ${order.status === 0
                        ? "bg-yellow-200 text-yellow-900"
                        : "bg-green-200 text-green-900"
                      }`}
                  >
                    {order.status === 0 ? "Pending" : "Completed"}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}